import { Action } from '@/_core/fluxstore/types';
import { ProductsState } from '../types';
import { useProductsStore } from '../useModule';
import { useLocalStorage } from 'vue-composable';

const { registerReducer } = useProductsStore();

export class ChangeCurrentProduct extends Action<ProductsState> {
    public static ACTION_TYPE = 'ChangeCurrentProduct';

    public constructor(public slug: string) {
        super(ChangeCurrentProduct.ACTION_TYPE);
    }
}

const reducer = (state: ProductsState, action: ChangeCurrentProduct): void => {
    state.currentProductSlug = action.slug;

    const existingProduct = state.products.find((x) => x.slug === action.slug);
    if (existingProduct == null) {
        if (state.products.length === 0) {
            state.currentProductSlug = null;
        } else {
            state.currentProductSlug = state.products[0].slug;
        }
    }

    const { storage: lastProductSlug } = useLocalStorage(`_storiesonboard_lastProductSlug-${initAppData.currentWs.workspaceId}`, null);
    lastProductSlug.value = state.currentProductSlug;
};

//@ts-ignore
registerReducer(ChangeCurrentProduct.ACTION_TYPE, reducer);
